<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
   <path fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.0829 20.82C11.0829 21.46 10.4929 21.94 9.87295 21.8C5.40295 20.8 2.08295 16.79 2.08295 12C2.08295 7.21002 5.40295 3.20002 9.87295 2.20002C10.4929 2.06002 11.0829 2.54002 11.0829 3.18002V20.82ZM13.1129 3.18002V9.99002C13.1129 10.54 13.5629 10.99 14.1129 10.99H20.9029C21.5429 10.99 22.0229 10.4 21.8829 9.77002C21.0329 6.01002 18.0829 3.05002 14.3329 2.20002C13.7029 2.06002 13.1129 2.54002 13.1129 3.18002ZM13.1129 20.82V14.01C13.1129 13.46 13.5629 13.01 14.1229 13H20.9129C21.5429 13 22.0329 13.6 21.8929 14.22C21.0429 17.98 18.0929 20.95 14.3329 21.8C13.7029 21.94 13.1129 21.46 13.1129 20.82Z"
          fill="currentColor"/>
  </svg>
</template>

<script>

export default {
  name: 'Statistics',
};
</script>
